import { Padrao } from '../generic/padrao';
import { SysCampo } from '../system/sysCampo';

export class ParametrosRegra extends Padrao{

    override idTab = 91;

    SysCampo: SysCampo = new SysCampo();
    nome: string;
    tipo: string;
    sistema: string;
    grupo: string;
    tipoObj: string;
    rotulo: string;
    valoresPadroes: string;
    objeto: string;
    descricao: string;
}